import React, { useEffect, useRef } from 'react'
import { Box, styled } from '@mui/material'

const ScrollingBox = styled(Box)(() => ({
  display: 'block',
  overflow: 'hidden',
  overflowY: 'auto',
  flex: '1 1 auto',
  height: 0,
  backgroundColor: 'white',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar ': {
    display: 'none',
  },
}))

export default function ScrollBox({
  tolerance = 0.95,
  shouldFetchNextPage,
  fetchNextPage,
  children,
  maxHeight,
  setScrollTop,
  scrollTo,
  setScrollTo,
}) {
  const scrollRef = useRef()
  const onScroll = (element) => {
    const { clientHeight, scrollTop, scrollHeight } = element.target

    const scrollPosition = clientHeight + scrollTop

    if (scrollPosition > scrollHeight * tolerance) {
      fetchNextPage()
    }

    if (setScrollTop && scrollTop > 1) {
      setScrollTop(scrollTop)
    }
  }

  const underScroll = (element) => {
    const { scrollTop } = element.target

    if (setScrollTop && scrollTop > 1) {
      setScrollTop(scrollTop)
    }
  }

  const onScrollTo = (top) => {
    scrollRef.current.scrollTo({ top })
  }

  // If screen is too big to display all the data, We need to fetchNextPage
  // The 100 is totally arbitrary, it is needed to avoid fetching when only the header is displayed
  useEffect(() => {
    if (!scrollTo && setScrollTo) {
      setScrollTo(() => onScrollTo)
    }
    if (shouldFetchNextPage && scrollRef.current.offsetHeight > 100) {
      if (scrollRef.current.clientHeight === scrollRef.current.scrollHeight) {
        fetchNextPage()
      }
    }
  })

  return (
    <ScrollingBox
      onScroll={shouldFetchNextPage ? onScroll : underScroll}
      maxHeight={maxHeight}
      ref={scrollRef}
    >
      <>{children}</>
    </ScrollingBox>
  )
}
